import React from 'react'
import { TrainingProgramFormUserPayload } from '../../types'
import { updateTrainingProgramFormUsers } from '../../slice'
import { useAppDispatch } from '../../../../../redux/store'
import TeamMemberModal from '../../components/TeamMemberModal'

interface TeamMemberFormModalPropTypes {
  teamMemberModalIsOpen: boolean;
  setTeamMemberModalIsOpen: (isOpen: boolean) => void;
  selectedForm: number | undefined;
  customerNumber: string;
  selectedFormTeamMembers: string[];
  programId?: number;
  sectionId: number;
}

const TeamMemberFormModal = (props: TeamMemberFormModalPropTypes) => {
  const {
    teamMemberModalIsOpen,
    setTeamMemberModalIsOpen,
    selectedForm,
    customerNumber,
    selectedFormTeamMembers,
    programId,
    sectionId
  } = props

  const dispatch = useAppDispatch()

  const onTeamMemberModalClose = () => setTeamMemberModalIsOpen(false)

  const handleSaveTeamMember = async (checkedTeamMembers: {[Identifier: string]: boolean}) => {
    const trainingProgramForms: TrainingProgramFormUserPayload[] = Object.keys(checkedTeamMembers).map((userId: string) => {
      const deletedDate = checkedTeamMembers[userId] ? null : new Date()
      return { user_id: Number(userId), deleted_date: deletedDate, program_id: programId, section_id: sectionId }
    })

    if (selectedForm) {
      const payload = {formId: selectedForm, customerNumber, trainingProgramForms}
      const action = updateTrainingProgramFormUsers(payload)
      await dispatch(action)
    }
  }

  return (
    <TeamMemberModal
      open={teamMemberModalIsOpen}
      onClose={onTeamMemberModalClose}
      onSave={handleSaveTeamMember}
      savedTeamMembers={selectedFormTeamMembers}
    />
  )
}

export default TeamMemberFormModal
